import React from 'react';
import { createPortal } from 'react-dom';

import styles from './styles.module.scss';

interface IPopupBackgroundProps {
  children: React.ReactNode,
  closeHandler: () => void,
  isOpen: boolean,
}

const PopupBackground = ({
  children,
  closeHandler,
  isOpen,
}: IPopupBackgroundProps) => (
  isOpen
    ? createPortal(
      <div className={styles.container}>
        <div
          className={styles.background}
          onClick={closeHandler}
        />
        {children}
      </div>,
      document.getElementById('root')!,
    )
    : null
);

export default PopupBackground;
